export default [
  {
    status: `Trying out @aerielab for the first time!

Let's see what they have in store 👀`,
  },
  {
    status: `You know what's better than shitposting?

Scheduling that shitpost. This is my first from @aerielab 😌`,
  },
  { status: `I wanna create more than I consume. @aerielab's gonna help me do that from now!` },
  {
    status: `I'm trying @aerielab for the first timeeee.

This is a code-speaking... meep morp zeeep.

Just kidding, it's still me (or is it?)`,
  },
  {
    status: `Just started using @aerielab

Let's see how this goes ✌️`,
  },
  {
    status: `Y'all gonna get more of this content cause I just started scheduling it :P  cc - @aerielab`,
  },
  {
    status: `Been seeing this Aerielab pop up a lot on my feed.. 👀

Thought I'd give it a try.

@aerielab`,
  },
  {
    status: `Am I a part of  Money Twitter..if I've finally tried @aerielab? :p`,
  },
  {
    status: `First tweet from @aerielab. Mic check 1 2..`,
  },
  {
    status: `Gonna engage more with y'all cause @aerielab will take care of my Tweeting times and shit.`,
  },
  {
    status: `Using @aerielab to double down on great content.`,
  },
  {
    status: `Good Morning to everyone except people who are against scheduling on Twitter.

In other news, I started trying @aerielab`,
  },
  {
    status: `You ain't working if you ain't working till 1AM.

Kidding.

I scheduled this first tweet from @aerielab yesterday.

I'm still sleeping rn. AUTOMATION RULES!`,
  },
  {
    status: `You don't need a reason to choose automation. You just need to have a life outside Twitter.

In other news, I'm trying @aerielab.`,
  },
  {
    status: `I'm finally choosing scheduling cause y'all deserve better than a tweet dump of 40 tweets in 4 hours.

@aerielab - Do your magic!`,
  },
  {
    status: `Can finally write - "@aerielab auto-plug tweets making me money when I sleep" or is it too soon?`,
  },
  {
    status: `I laid my hands on Twitter cheat code.

It's called @aerielab 👀`,
  },
  {
    status: `I'm becoming a TWITTER MACHINE. Of course, it was about time to try @aerielab`,
  },
  {
    status: `I'm gonna do magic here.

I'm still asleep but this tweet is getting posted.

cc - @aerielab`,
  },
  {
    status: `Finally doing it ft. @aerielab`,
  },
  {
    status: `Major afk vibes. ft. @aerielab`,
  },
  {
    status: `.@aerielab do your magicxx pls`,
  },
  {
    status: `YES I do! Trying it today @aerielab`,
  },
  {
    status: `Letsss go baby!! @aerielab`,
  },
  {
    status: `My wife wanted me to leave Twitter and go for dinner.

I couldn't leave Twitter.

So, @aerielab is doing it for me now :)`,
  },
  {
    status: `I love being here and tweeting

But I got a life

Thanks @aerielab!`,
  },
  {
    status: `I came here after the Aerielab v Other tool drama 👀
Let's see what they've got!

cc - @aerielab`,
  },
  {
    status: `I started using @aerielab a few hours back and I've already scheduled tweets for the next week.

Aerielab is awesome!`,
  },
  {
    status: `Started using @aerielab today.

Loads of inspiration and tweets already!`,
  },
  {
    status: `I'm trying out @aerielab

Because I ..

- am not an AI
- want to tweet real-life shit
- don't want to spend 23 hours on Twitter`,
  },
  {
    status: `They said I could make money from Twitter 👀👀👀
Lemme see how that works!

In other news, trying @aerielab`,
  },
  {
    status: `It's gonna be a tough choice to choose between

Scheduling memes

Or

Scheduling "websites that feel illegal to know"

What should be my first tweet with @aerielab?`,
  },
  { status: `In other news, I’m trying @aerielab` },
  { status: `Gonna be a tough choice now that I’m using @aerielab` },
  {
    status: `Just wanted to remind myself that I have a life outside Twitter.

So trying @aerielab`,
  },
  {
    status: `Started using @aerielab

I’ll blame them if I spend 19 hrs here now`,
  },
  { status: `Thanks @aerielab!` },
  {
    status: `It do be like that sometimes

cc - @aerielab`,
  },
];
